import { render, staticRenderFns } from "./reset-password-without-security-questions.vue?vue&type=template&id=65806d16&"
import script from "./reset-password-without-security-questions.vue?vue&type=script&lang=js&"
export * from "./reset-password-without-security-questions.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-without-security-questions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports